/**
 * @generated SignedSource<<9fbde99b6888c99f315fe0fad485f1b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CopyJobMutation$variables = {
  id: string;
  key: string;
};
export type CopyJobMutation$data = {
  readonly copyJob: {
    readonly id: string;
  } | null;
};
export type CopyJobMutation = {
  response: CopyJobMutation$data;
  variables: CopyJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Job",
    "kind": "LinkedField",
    "name": "copyJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CopyJobMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CopyJobMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bed2a3161b5ee0fe93ed2aaba3e7339c",
    "id": null,
    "metadata": {},
    "name": "CopyJobMutation",
    "operationKind": "mutation",
    "text": "mutation CopyJobMutation(\n  $id: ID!\n  $key: String!\n) {\n  copyJob(input: {id: $id, key: $key}) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce3b87381e3397ac892bac9a0d40003b";

export default node;
